var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "USDC 40px") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo&buttom-svg",
    transform: "translate(-494.000000, -748.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "USDC-40px",
    transform: "translate(494.000000, 748.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,40 C31.0834,40 40,31.0834 40,20 C40,8.9166 31.0834,0 20,0 C8.9166,0 0,8.9166 0,20 C0,31.0834 8.9166,40 20,40 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#2775CA",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5,23.1666 C25.5,20.25 23.75,19.25 20.25,18.8334 C17.75,18.5 17.25,17.8334 17.25,16.6666 C17.25,15.4998 18.0834,14.75 19.75,14.75 C21.25,14.75 22.0834,15.25 22.5,16.5 C22.5834,16.75 22.8334,16.9166 23.0834,16.9166 L24.4166,16.9166 C24.75,16.9166 25,16.6666 25,16.3334 L25,16.25 C24.6666,14.4166 23.1666,13 21.25,12.8334 L21.25,10.8334 C21.25,10.5 21,10.25 20.5834,10.1666 L19.3334,10.1666 C19,10.1666 18.75,10.4166 18.6666,10.8334 L18.6666,12.75 C16.1666,13.0834 14.5834,14.75 14.5834,16.8334 C14.5834,19.5834 16.25,20.6666 19.75,21.0834 C22.0834,21.5 22.8334,22 22.8334,23.3334 C22.8334,24.6668 21.6666,25.5834 20.0834,25.5834 C17.9166,25.5834 17.1666,24.6666 16.9166,23.4166 C16.8334,23.0834 16.5834,22.9166 16.3334,22.9166 L14.9166,22.9166 C14.5834,22.9166 14.3334,23.1666 14.3334,23.5 L14.3334,23.5834 C14.6666,25.6666 16,27.1666 18.75,27.5834 L18.75,29.5834 C18.75,29.9166 19,30.1666 19.4166,30.25 L20.6666,30.25 C21,30.25 21.25,30 21.3334,29.5834 L21.3334,27.5834 C23.8334,27.1666 25.5,25.4166 25.5,23.1666 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3334,15.9166 C5.9166,22.3334 9.25,29.5834 15.75,31.9166 C16,32.0834 16.25,32.4166 16.25,32.6666 L16.25,33.8333333 C16.25,34 16.25,34.0833333 16.1666,34.1666667 C16.0834,34.5 15.75,34.6666667 15.4166,34.5 C10.75,33 7.1666,29.4166 5.6666,24.75 C3.16659667,16.8334 7.5,8.4166 15.4166,5.9166 C15.5,5.8334 15.6666,5.8334 15.75,5.8334 C16.0834,5.9166 16.25,6.1666 16.25,6.5 L16.25,7.6666 C16.25,8.0834 16.0834,8.3334 15.75,8.5 C12.3334,9.75 9.5834,12.4166 8.3334,15.9166 Z M23.8334,6.25 C23.9166,5.9166 24.25,5.75 24.5834,5.9166 C29.1666,7.4166 32.8334,11 34.3333333,15.75 C36.8333333,23.6666 32.5,32.0834 24.5834,34.5833333 C24.5,34.6666667 24.3334,34.6666667 24.25,34.6666667 C23.9166,34.5833333 23.75,34.3333333 23.75,34 L23.75,32.8334 C23.75,32.4166 23.9166,32.1666 24.25,32 C27.6666,30.75 30.4166,28.0834 31.6666,24.5834 C34.0833333,18.1666 30.75,10.9166 24.25,8.5834 C24,8.4166 23.75,8.0834 23.75,7.75 L23.75,6.5834 C23.75,6.4166 23.75,6.3334 23.8334,6.25 Z",
    id: "\\u5F62\\u72B6",
    fill: "#FFFFFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsd);
export default __webpack_public_path__ + "static/media/usd.141e1eb328a48766341ad854790f5208.svg";
export { ForwardRef as ReactComponent };